import { Building2 } from "lucide-react";
import EmpresaMetrics from "./EmpresaMetrics";
import EmpresaSimpleView from "./EmpresaSimpleView";
import EmpresaAdminView from "./EmpresaAdminView";

/**
 * Tarjeta de empresa expandible con métricas y detalles
 */
export default function EmpresaCard({
    empresa,
    modo,
    isNocAdmin,
    canSeeTarifas,
    fechaCorte,
    onToggleEmpresa,
    onNavigateTransactions,
    onOpenBalanceModal,
    onToggleCliente,
}) {
    const { id, nombre, open, resumen, clientesOpen, troncales } = empresa;

    return (
        <div className="rounded-md border border-slate-200 bg-white shadow-sm mb-2 overflow-hidden">
            {/* Header de la empresa */}
            <div
                role="button"
                tabIndex={0}
                className="w-full p-2 flex items-center justify-between hover:bg-slate-50 transition-all group"
                onClick={() => onToggleEmpresa(id)}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        onToggleEmpresa(id);
                    }
                }}
            >
                {/* Izquierda: Icono + Nombre */}
                <div className="flex items-center gap-3 min-w-0 basis-[320px] sm:basis-[380px] md:basis-[440px] lg:basis-[520px]">
                    <span className="inline-flex items-center justify-center shrink-0 w-6 h-6 rounded-lg bg-slate-100 border border-slate-200">
                        <Building2 className="w-4 h-4 text-slate-600" aria-hidden="true" />
                    </span>

                    <div className="min-w-0">
                        <div className="font-medium text-slate-800 truncate" title={nombre}>
                            {nombre}
                        </div>
                    </div>
                </div>

                {/* Derecha: Métricas financieras */}
                <EmpresaMetrics
                    resumen={resumen}
                    modo={modo}
                    isNocAdmin={isNocAdmin}
                    onNavigateTransactions={() => onNavigateTransactions(id, nombre)}
                    onOpenBalanceModal={() => onOpenBalanceModal(id)}
                />
            </div>

            {/* Panel expandible con detalles */}
            <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${open ? "max-h-[900px] opacity-100" : "max-h-0 opacity-0"
                    }`}
            >
                <div className="border-t border-slate-100">
                    {!resumen ? (
                        <div className="p-3 text-xs text-slate-500 bg-slate-50 flex items-center gap-3">
                            <span className="text-lg">⚠️</span>
                            <span>No se pudo cargar el resumen de esta empresa.</span>
                        </div>
                    ) : modo === "empresa" ? (
                        <EmpresaSimpleView resumen={resumen} />
                    ) : (
                        <EmpresaAdminView
                            resumen={resumen}
                            fechaCorte={fechaCorte}
                            canSeeTarifas={canSeeTarifas}
                            clientesOpen={clientesOpen}
                            troncales={troncales}
                            onToggleCliente={onToggleCliente}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}